import * as React from 'react';

function IconPhoneSolid(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>): React.JSX.Element {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="inline-flex h-[1.715em] w-[1.715em] flex-shrink-0"
            data-taco="icon"
            data-icon-name="phone-solid"
            focusable="false"
            role="img"
            ref={svgRef}
            {...props}>
            <path
                d="M5.35688 4.38397L6.24814 3.80474C7.0833 3.26198 8.18967 3.48109 8.83361 4.31673L10.1149 5.97974C10.6733 6.7044 10.7418 7.71417 10.2843 8.47618L9.01117 10.5966C9.38326 11.5612 9.97314 12.4512 10.7808 13.2665C11.5885 14.0818 12.489 14.6964 13.4824 15.1102L15.3581 13.8568C16.0691 13.3817 17.0026 13.4587 17.6747 14.0477L19.2402 15.42C20.0215 16.1047 20.2296 17.2824 19.7271 18.1751L19.1886 19.1317C18.6526 20.0839 17.6717 20.6401 16.6134 20.5917C14.1148 20.4773 11.4161 18.8736 8.51702 15.7806C5.61372 12.6829 4.10894 9.79794 4.00269 7.12574C3.95799 6.00131 4.47314 4.95831 5.35688 4.38397Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
}
export default React.forwardRef(IconPhoneSolid);
